module.exports = __webpack_public_path__ + "img/fx_pro_Android.75703f09.png";